var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowsUpDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.953 2.867c.125 0 .245.05.333.14l2.286 2.334a.467.467 0 0 1-.667.653L5.419 4.477v7.801a.467.467 0 0 1-.933 0v-7.8L3 5.993a.467.467 0 1 1-.667-.653L4.62 3.007a.47.47 0 0 1 .334-.14m6.095.39c.258 0 .466.208.466.466v7.8L13 10.008a.467.467 0 1 1 .667.653l-2.286 2.334a.467.467 0 0 1-.667 0L8.43 10.66a.467.467 0 1 1 .666-.653l1.486 1.517V3.723c0-.258.21-.467.467-.467",
  clipRule: "evenodd"
})));
export default SvgArrowsUpDown;